import { Directive, ElementRef, Input, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[upscAppendCommaIfNotEmpty]' })
export class AppendCommaIfNotEmptyDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private renderer: Renderer2,
        private el: ElementRef,
    ) {
    }

    @Input() set upscAppendCommaIfNotEmpty(value: any) {
        if (!value) {
            this.viewContainer.clear();
            return;
        }

        this.viewContainer.clear();
        const embeddedView = this.viewContainer.createEmbeddedView(this.templateRef);
        const rootElement = embeddedView.rootNodes[0];
        this.renderer.setProperty(rootElement, 'textContent', `${ value }, `);
    }
}
